import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import GalleryPage from "./pages/GalleryPage";
import EventsPage from "./pages/EventsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ReservationPage from "./pages/ReservationPage";
import ValentinePage from "./pages/ValentinePage";
import FloatingCallButton from "./components/landing/FloatingCallButton";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* Valentine's Day special page */}
          <Route path="/valentine" element={<ValentinePage />} />
          <Route path="/valentine-special" element={<ValentinePage />} />
          {/* Hidden reservation page for testing - not linked in nav yet */}
          <Route path="/reserve" element={<ReservationPage />} />
        </Routes>
        <FloatingCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
